export const REDUCER_NAME = 'manage'



// WEBPACK FOOTER //
// ./src/modules/security/state/manage/const.js